<template>
  <b-modal
    id="modal-scoped"
    ref="modal-scoped"
    no-close-on-backdrop
    hide-footer
    :visible="showModalSignUp"
    cancel-disabled
    centered
    size="lg"
    @close="closeModal"
    @hide="closeModal"
    data-cy="modal-cadastro-principal"
  >
    <template>
      <div class="card p-3" data-cy="card-cadastro-social">
        <div
          class="d-flex flex-column align-items-center w-100 mb-2"
          data-cy="header-cadastro-social"
        >
          <h4
            class="text-primary font-weight-bold mb-0"
            data-cy="titulo-cadastro-social"
          >
            Inscreva-se com
          </h4>
        </div>
        <div
          class="d-flex flex-row justify-content-center"
          data-cy="botoes-cadastro-social"
        >
          <button
            type="button"
            @click="authenticate('facebook')"
            class="btn btn-lg text-nowrap btn mr-3"
            data-cy="btn-cadastro-facebook"
            style="background-color: #3b5796; color: white;"
          >
            <font-awesome-icon
              class="mr-lg-2"
              :icon="['fab', 'facebook-square']"
              data-cy="btn-cadastro-facebook-icon"
            />
            Facebook
          </button>
          <button
            type="button"
            @click="authenticate('google')"
            class="btn btn-lg text-nowrap btn"
            data-cy="btn-cadastro-google"
            style="background-color: #e74a4a; color: white;"
          >
            <font-awesome-icon
              class="mr-lg-3"
              :icon="['fab', 'google']"
              data-cy="btn-cadastro-google-icon"
            />
            Google
          </button>
        </div>
      </div>
      <div
        class="d-flex flex-column align-items-center w-100"
        data-cy="separador-cadastro"
      >
        <small
          class="font-weight-bold text-center m-2"
          data-cy="texto-separador"
        >OU
        </small>
      </div>
      <div class="card p-3" data-cy="card-formulario-cadastro">
        <div
          class="d-flex flex-column align-items-center w-100"
          data-cy="header-formulario-cadastro"
        >
          <h4
            class="text-primary font-weight-bold mb-0"
            data-cy="titulo-formulario-cadastro"
          >
            Cadastre-se
          </h4>
          <small data-cy="subtitulo-formulario-cadastro"
          >Precisamos de algumas informações para confirmarmos seu cadastro, é
            rapidinho.</small
          >
        </div>
        <form
          class="needs-validation"
          novalidate
          data-cy="form-cadastro-paciente"
        >
          <div class="form-row" data-cy="row-campo-nome">
            <div class="col-12" data-cy="col-campo-nome">
              <div class="form-group" data-cy="campo-nome-form-group">
                <label for="nome" v-required data-cy="campo-nome-label">
                  Nome {{ paciente.temNomeSocial ? "Social" : "" }}
                </label>
                <b-input
                  :state="validateStatePaciente('nome')"
                  class="form-control"
                  id="nome"
                  ref="nome"
                  placeholder="Nome do paciente"
                  v-model="$v.paciente.nome.$model"
                  data-cy="campo-nome-input"
                ></b-input>
                <div class="invalid-feedback" data-cy="campo-nome-erro">
                  Por favor, informe seu nome completo.
                </div>
              </div>
            </div>
            <div class="col-12" data-cy="col-nome-social-toggle">
              <div class="form-group" data-cy="campo-nome-social-form-group">
                <label class="switch" data-cy="campo-nome-social-switch">
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="paciente.temNomeSocial"
                    v-on:change="
                      !paciente.temNomeSocial ? (paciente.nomeCivil = null) : ''
                    "
                    data-cy="campo-nome-social-checkbox"
                  />
                  <span
                    class="slider round"
                    data-cy="campo-nome-social-slider"
                  ></span>
                </label>
                <span data-cy="campo-nome-social-texto">
                  Indicar que é nome social.</span
                >
              </div>
            </div>
            <br />
          </div>
          <div
            class="form-row"
            v-show="paciente.temNomeSocial"
            data-cy="row-campo-nome-civil"
          >
            <div class="col-12" data-cy="col-campo-nome-civil">
              <div class="form-group" data-cy="campo-nome-civil-form-group">
                <label for="nome" data-cy="campo-nome-civil-label">
                  <strong>
                    Nome Civil
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-input
                  :state="validateStatePaciente('nomeCivil')"
                  class="form-control"
                  id="nomeCivil"
                  ref="nomeCivil"
                  placeholder="Nome Civil do paciente"
                  v-model.trim="$v.paciente.nomeCivil.$model"
                  data-cy="campo-nome-civil-input"
                ></b-input>
                <div class="invalid-feedback" data-cy="campo-nome-civil-erro">
                  Por favor, informe o nome civil.
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" data-cy="row-campo-telefone">
            <div class="col-12" data-cy="col-campo-telefone">
              <div class="form-group" data-cy="campo-telefone-form-group">
                <label for="telefone" data-cy="campo-telefone-label">
                  <strong>
                    Celular
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-input
                  :state="validateStatePaciente('telefonePrincipal')"
                  class="form-control"
                  id="telefone"
                  ref="telefone"
                  placeholder="(00) 00000-0000"
                  v-model="$v.paciente.telefonePrincipal.$model"
                  v-mask="[`(##) ####-####`, `(##) #####-####`]"
                  data-cy="campo-telefone-input"
                ></b-input>
                <div class="invalid-feedback" data-cy="campo-telefone-erro">
                  Por favor, informe seu telefone ou celular.
                </div>
              </div>
            </div>
          </div>

          <div class="form-row" data-cy="row-sexo-data-nascimento">
            <div class="col-4" data-cy="col-campo-sexo">
              <div class="form-group" data-cy="campo-sexo-form-group">
                <label for="sexo" data-cy="campo-sexo-label">
                  <strong>
                    Sexo
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-form-select
                  v-model="paciente.sexo"
                  :options="genders"
                  id="sexo"
                  ref="sexo"
                  data-cy="campo-sexo-select"
                ></b-form-select>
              </div>
            </div>
            <div class="col" data-cy="col-campo-data-nascimento">
              <div
                class="form-group"
                data-cy="campo-data-nascimento-form-group"
              >
                <label
                  for="datanascimento"
                  data-cy="campo-data-nascimento-label"
                >
                  <strong>
                    Data de Nascimento
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-input
                  :state="validateStatePaciente('dataNascimento')"
                  class="form-control"
                  id="datanascimento"
                  ref="datanascimento"
                  v-model="$v.paciente.dataNascimento.$model"
                  :maxlength="10"
                  placeholder="dd/mm/aaaa"
                  v-mask="[`##/##/####`]"
                  data-cy="campo-data-nascimento-input"
                ></b-input>
                <div
                  class="invalid-feedback"
                  data-cy="campo-data-nascimento-erro"
                >
                  Não é uma data válida.
                </div>
              </div>
            </div>
          </div>

          <div class="form-row" data-cy="row-campo-email">
            <div class="col-12" data-cy="col-campo-email">
              <div class="form-group" data-cy="campo-email-form-group">
                <label for="email" data-cy="campo-email-label">
                  <strong>
                    Email
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-form-input
                  v-model="$v.paciente.email.$model"
                  class="form-control"
                  id="email"
                  placeholder="Email"
                  type="email"
                  ref="email"
                  :state="validateStatePaciente('email')"
                  data-cy="campo-email-input"
                />
                <div class="invalid-feedback" data-cy="campo-email-erro">
                  Por favor, informe um email válido.
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" data-cy="row-documento">
            <div class="col-6 col-md-auto" data-cy="col-tipo-documento">
              <div class="form-group" data-cy="campo-tipo-documento-form-group">
                <label for="tipodocumento" data-cy="campo-tipo-documento-label"
                >Tipo documento</label
                >
                <b-form-select
                  v-model="paciente.tipoDocumento"
                  :options="documentTypes"
                  id="tipodocumento"
                  data-cy="campo-tipo-documento-select"
                ></b-form-select>
              </div>
            </div>
            <div class="col-6 col-md" data-cy="col-numero-documento">
              <div
                class="form-group"
                data-cy="campo-numero-documento-form-group"
              >
                <label
                  for="numerodocumento"
                  class="text-nowrap"
                  data-cy="campo-numero-documento-label"
                >Nº do documento</label
                >
                <b-input
                  type="tel"
                  class="form-control"
                  :state="validateStatePacienteDocumento('numeroDocumento')"
                  v-model="$v.paciente.numeroDocumento.$model"
                  id="numerodocumento"
                  ref="numerodocumento"
                  v-mask="
                    paciente.tipoDocumento === 'CPF'
                      ? '###.###.###-##'
                      : 'XXXXXXXXXXXXXXXXXXXX'
                  "
                  data-cy="campo-numero-documento-input"
                ></b-input>
                <div
                  class="invalid-feedback"
                  data-cy="campo-numero-documento-erro"
                >
                  CPF inválido.
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" data-cy="row-campo-senha">
            <div class="col-12" data-cy="col-campo-senha">
              <div class="form-group" data-cy="campo-senha-form-group">
                <label for="nome" data-cy="campo-senha-label">
                  <strong>
                    Senha
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-input
                  :state="validateStatePaciente('senha')"
                  class="form-control"
                  id="senha"
                  ref="senha"
                  v-model="$v.paciente.senha.$model"
                  :type="!obscure ? `text` : `password`"
                  data-cy="campo-senha-input"
                ></b-input>
                <div class="invalid-feedback" data-cy="campo-senha-erro">
                  Por favor, informe uma senha.
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" data-cy="row-campo-confirmar-senha">
            <div class="col-12" data-cy="col-campo-confirmar-senha">
              <div
                class="form-group"
                data-cy="campo-confirmar-senha-form-group"
              >
                <label for="nome" data-cy="campo-confirmar-senha-label">
                  <strong>
                    Confirme a Senha
                    <span class="text-danger">*</span>
                  </strong>
                </label>
                <b-input
                  :state="validateStatePaciente('confirmarSenha')"
                  class="form-control"
                  id="confirmar-senha"
                  ref="confirmar-senha"
                  v-model="$v.paciente.confirmarSenha.$model"
                  :type="!obscure ? `text` : `password`"
                  data-cy="campo-confirmar-senha-input"
                ></b-input>
                <div
                  class="invalid-feedback"
                  data-cy="campo-confirmar-senha-erro"
                >
                  As senhas informadas não são iguais.
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" data-cy="row-aceita-politicas">
            <div class="col-12" data-cy="col-aceita-politicas">
              <div
                class="form-group"
                data-cy="campo-aceita-politicas-form-group"
              >
                <b-form-checkbox
                  id="cb-cadastro"
                  class="mt-3"
                  v-model="$v.aceitaPoliticas.$model"
                  name="cb-cadastro"
                  :state="validateStatePoliticas()"
                  data-cy="checkbox-aceita-politicas-cadastro"
                >
                  Eu concordo com a
                  <a
                    target="_blank"
                    :href="urls.politicaPrivacidadeLink"
                    data-cy="link-politica-privacidade-cadastro"
                  >
                    Política de Privacidade
                  </a>
                  e com o
                  <a
                    target="_blank"
                    :href="urls.termoUsoLink"
                    data-cy="link-termo-uso-cadastro"
                  >
                    Termo de Uso
                  </a>
                  <b-form-invalid-feedback
                    :state="validateStatePoliticas()"
                    data-cy="erro-aceita-politicas"
                  >
                    É necessário informar que concorda com a Política de
                    Privacidade e com os Termos de Uso para realizar o cadastro.
                  </b-form-invalid-feedback>
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <input
            @click.prevent="register"
            type="submit"
            :class="
              `btn btn-primary btn-lg d-flex justify-content-center align-items-center my-3 w-100`
            "
            :value="!loading ? `Criar conta` : `Aguarde...`"
            data-cy="btn-criar-conta"
          />
        </form>
      </div>
    </template>
  </b-modal>
</template>
<script>
import { documentTypes, genders, validCPF } from "@/core/enumHelper";
import { mask } from "vue-the-mask";
import { axiosInstance as Axios } from "@/main";
import moment from "moment";
import {
  email,
  maxLength,
  minLength,
  required,
  requiredIf,
  sameAs
} from "vuelidate/lib/validators";

export default {
  name: "modal-user-signUp",
  directives: {
    mask
  },
  computed: {
    showModalSignUp() {
      return this.$store.getters.show_modalSignUp;
    },
    actual() {
      return this.$store.getters.actual;
    },
    go() {
      return this.$store.getters.to;
    },
    genders() {
      return Object.values(genders);
    },
    documentTypes() {
      return Object.values(documentTypes);
    },
    user() {
      return this.$store.getters.user;
    },
    to() {
      return this.$store.getters.to;
    },
    urls() {
      return this.$store.getters.urls;
    }
  },
  data() {
    return {
      obscure: true,
      confirmPassword: null,
      loading: false,
      paciente: {
        dataNascimento: null,
        dependente: true,
        email: null,
        id: 0,
        nome: null,
        temNomeSocial: false,
        nomeCivil: null,
        numeroDocumento: null,
        senha: null,
        confirmarSenha: null,
        sexo: genders.INDEFINIDO,
        telefonePrincipal: null,
        tipoDocumento: documentTypes.CPF
      },
      aceitaPoliticas: false
    };
  },
  validations: {
    paciente: {
      nome: {
        required,
        minLength: minLength(4)
      },
      telefonePrincipal: {
        required,
        minLength: minLength(14),
        maxLength: maxLength(15)
      },
      nomeCivil: {
        required: requiredIf(function(pacienteModel) {
          return pacienteModel.temNomeSocial;
        }),
        minLength: minLength(4)
      },
      email: {
        required,
        email
      },
      dataNascimento: {
        required,
        minLength: minLength(10),
        maxValue(val) {
          val = moment(val, "DD/MM/YYYY");
          return moment(val) < moment();
        }
      },
      senha: {
        required
      },
      confirmarSenha: {
        required,
        sameAsPassword: sameAs("senha")
      },
      numeroDocumento: {
        isCpf(val) {
          if (
            this.paciente.tipoDocumento === "CPF" &&
            val !== "" &&
            val !== null
          ) {
            if (!validCPF(val.replace(/[^0-9]/g, ""))) {
              return false;
            }
          }
          return true;
        }
      }
    },
    aceitaPoliticas: {
      sameAs: sameAs(() => true)
    }
  },
  mounted() {},
  methods: {
    async authenticate(method) {
      try {
        // XXX: importante caso o usuário acesse utilizando alguns navegadores imbutidos de alguns apps (como instagram)
        sessionStorage.setItem(
          "mol.oauthMethod",
          method
        );

        console.log(
          "mol.oauthMethod",
          method
        );

        let response =
          await this.$auth.authenticate(method);

        let resp;

        try {
          resp = await Axios.post(
            `/social/auth/${method}`,
            {
              ...response
            }
          );
        } catch (e) {
          console.error(e);

          return;
        }

        console.log(
          method,
          "auth response",
          resp
        );

        let payload = {
          url: this.$serverHost,
          token: resp.data.token,
          organizationId:
          this.$route.params.organizationId,

          redirect: () => {
            if (this.go) {
              this.$router.push(
                this.go
              );
            } else if (this.actual) {
              this.$router.push(
                this.actual
              );
            } else {
              this.$router.push({
                name: "consulta_convenio",
                params: {
                  organizationId:
                  this.$route.params.organizationId
                }
              });
            }

            this.loading = false;
          }
        };

        await this.$store.dispatch(
          "login_social",
          payload
        );
      } catch (e) {
        console.log(e);
      }
    },
    validateStatePaciente(name) {
      const { $dirty, $error } = this.$v.paciente[name];
      return $dirty ? !$error : null;
    },
    validateStatePacienteDocumento(name) {
      const { $dirty, $error } = this.$v.paciente[name];
      if (this.$v.paciente[name].$model === "") {
        return;
      }
      return $dirty ? !$error : null;
    },
    validateStatePoliticas() {
      const { $dirty, $error } = this.$v.aceitaPoliticas;
      return $dirty ? !$error : null;
    },
    async register() {
      this.$v.paciente.nome.$touch();
      this.$v.paciente.telefonePrincipal.$touch();
      this.$v.paciente.nomeCivil.$touch();
      this.$v.paciente.email.$touch();
      this.$v.paciente.dataNascimento.$touch();
      this.$v.paciente.senha.$touch();
      this.$v.paciente.confirmarSenha.$touch();
      this.$v.aceitaPoliticas.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.loading = true;

      var pacienteSend = Object.assign({}, this.paciente);

      pacienteSend.dataNascimento = pacienteSend.dataNascimento.replace(
        /(..)\/(..)\/(....)/,
        "$3-$2-$1 23:59"
      );

      try {
        let response = await Axios.post(
          `${this.$serverHost}social/usuarios`,
          pacienteSend
        );
        let payload = {
          url: this.$serverHost,
          token: response.data.token,
          organizationId: this.$route.params.organizationId,
          redirect: () => {
            if (this.actual) {
              this.$router.push(this.actual);
            } else {
              this.$router.push({
                name: "index",
                params: { organizationId: this.$route.params.organizationId }
              });
            }
          }
        };

        this.$store.commit("set_token", payload);
        await this.$store.dispatch("load_user", payload);
        this.$router.push(this.to);
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.paciente.dataNascimento = null;
      this.paciente.dependente = true;
      this.paciente.email = null;
      this.paciente.id = 0;
      this.paciente.nome = null;
      this.paciente.nomeCivil = null;
      this.paciente.numeroDocumento = null;
      this.paciente.senha = null;
      this.paciente.sexo = genders.INDEFINIDO;
      this.paciente.telefonePrincipal = null;
      this.paciente.tipoDocumento = documentTypes.CPF;
      this.aceitaPoliticas = false;

      this.$v.$reset();
      this.loading = false;
      this.$store.dispatch("set_modalSignUp", false);
    }
  }
};
</script>
